/**
 * Constants for Table Order Module
 * Centralized location for magic numbers and strings
 */

/**
 * Order status values
 */
export const ORDER_STATUS = {
  OPEN: 1,
  COMPLETED: 2,
  CLOSED: 3,
  CANCELLED: 4
};

/**
 * IndexedDB store names
 */
export const INDEXED_DB_STORES = {
  TABLE_ORDER_ITEMS: "tableOrderItems"
};

/**
 * UI Breakpoints
 */
export const BREAKPOINTS = {
  MOBILE_MAX: 1024
};
